export default "__VITE_ASSET__CZSD8UTB__"